import { Button, Divider, message } from "antd";
import Typography from "antd/es/typography/Typography";
import IconSuccess  from "./success-icon.svg";
import PhoneIcon from "./phone.svg";
import EmailIcon from "./email.svg";
import ArrowRight from "./arrow-right.svg";
import BG from "./order-bg.svg";
import { ArrowLeftOutlined } from "@ant-design/icons";
import { useNavigate, useParams } from "react-router-dom";
import api from "../../../../api/api";
import React,{ useEffect, useState } from "react";
import moment from "moment";
import { useTranslation } from "react-i18next";


const OrderDetails = ({ data }) => {

  const [orderDetails, setOrderDetails] = useState({});
  const [dataLoaded, setDataLoaded] = React.useState(false);

  const {t} = useTranslation();
  

  const { id } = useParams();

  const navigate = useNavigate();

  const handleBackRoute = () => {
    navigate("/home/template-management/edit-template");
  }


    const getOrderDetails = (id) => {
      api
        .storePublicOrderDetails(id)
        .then((data) => {
          setOrderDetails(data);
        })
        .catch((error) => {
          message.error(error);
        });
    };

    // getOrderDetails();

      useEffect(() => {
        Promise.all([
         getOrderDetails(id)
        ]).finally(() => setDataLoaded(true));
        // eslint-disable-next-line
      }, []);

const handlePhoneClick = () => {
  const phoneNumbers = orderDetails?.data?.contact?.phone_numbers;
  if (phoneNumbers?.length > 0) {
    window.location.href = `tel:${phoneNumbers[0]}`;
  }
};

const handleEmailClick = () => {
  const email = orderDetails?.data?.contact?.email;
  if (email) {
    window.location.href = `mailto:${email}`;
  }
};

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        padding: "40px 16px",
        backgroundCIconSuccessolor: "#F7F8FB",
        minHeight: "100vh",
      }}
    >
      <div onClick={handleBackRoute} style={{display:"flex",cursor:"pointer",alignItems:"center",gap:"20px",marginBottom:"30px",justifyContent:"start",width:"780px"}}>
        <div style={{border:"1px solid #EAEAEA",borderRadius:"8px",width:"40px",height:"40px",display:"flex", justifyContent:"center", alignItems:"center"}}>
         {/* <img /> */}
         <ArrowLeftOutlined/>
        </div>
        <p style={{fontSize:"24px",color:"#1A1A1A",fontWeight:700,}}>{t('order_details')}</p>
      </div>
      <div
        style={{
          width: "100%",
          maxWidth: 780,
          backgroundColor: "#fff",
          borderRadius: 16,
          overflow: "hidden",
          borderTopLeftRadius:"24px",
          borderTopRightRadius:"24px",
          position:"relative",
        }}
      >
        {/* Top Section - Blue Header */}
        <div
          style={{
            backgroundColor: "#1859FF",
            padding: 26,
            color: "white",
            width:"100%",
            minHeight:"240px",
            display:"flex",
            justifyContent:"center",
            alignItems:"start",
          }}
        >
         
          <div style={{display:"flex",flexDirection:"column",gap:"0px",alignItems:"start",padding:"0px 20px",zIndex:"99",textAlign:"left",width:"100%"}}>
          <div style={{ display: "flex", alignItems: "center", gap: 3 }}>
             <img src={IconSuccess} alt="success-icon" style={{width:"35px",height:"35px"}}/>
            <Typography style={{ fontSize: 32, fontWeight: "bold", color: "#fff" }}>
              {t('order_success')}
            </Typography>
          </div>
          <Typography style={{ marginTop: 8, fontSize: 16, color: "#fff",padding:"10px 20px" }}>
            {t('order_success_text')}
           
          </Typography>
        </div>
         <img src={BG} alt="order-bg"  style={{
            position:"absolute",
            top:0,
            right:0,
            left:0,
            bottom:0,
            background:"contain",
            // zIndex:"-1",
            width:"95%",
            height:"auto"
          }} />
        </div>
        <div style={{backgroundColor:"#fff",borderTopRightRadius:"24px",borderTopLeftRadius:"24px",marginTop:"-100px",zIndex:"99999 !important"}}>
        {/* White Body Section */}
        <div style={{ padding: 32, display: "flex", flexDirection: "column", gap: 24 }}>
          {/* Order Details */}
          <div style={{ display: "flex", flexDirection: "column", gap: 16 }}>
            <Typography style={{ fontWeight: "bold" }}>{t('order_details')}</Typography>
            {[
              { label: t('invoice_number'), value: orderDetails?.data?.transaction_no || "-" },
              { label: t('date'), value: moment(orderDetails?.data?.created_at).format("DD MMM YYYY")  },
              { label: t('type'), value: orderDetails?.data?.type === "HOSTING_FEE" ? "Hosting Fee" : "-" },
              { label: t('store_name'), value: orderDetails?.data?.store?.name },
              { label: t('template_id'), value: orderDetails?.data?.template?.template_code },
            ].map((item, i) => (
              <div
                key={i}
                style={{ display: "flex", justifyContent: "space-between", fontSize: 14 }}
              >
                <Typography>{item.label}</Typography>
                <Typography>{item.value}</Typography>
              </div>
            ))}
          </div>
          {/* Payment Details */}
          <div style={{ display: "flex", flexDirection: "column", gap: 16 }}>
             <Divider />
            <Typography style={{ fontWeight: "bold" }}>{t('payment_details')}</Typography>
                {[
            { label: t('pay_with'), value: orderDetails?.data?.payment_method},
            { label: t('payment_status'), value: orderDetails?.data?.status === "SUCCESS" ? t('successful') : t('failed')},
            { label: t('hosting_fee_store'), value: `$${orderDetails?.data?.hosting_fee}` },
            { label: t('sub_total'), value: `$${orderDetails?.data?.subtotal}` },
          ].map((item, i) => (
            <div key={i}>
              {item?.label === t('sub_total') && <Divider />}
              <div
                style={{ display: "flex", justifyContent: "space-between", fontSize: 14 }}
              >
                <Typography>{item.label}</Typography>
                <Typography>{item.value}</Typography>
              </div>
              {item?.label === t('sub_total') && <Divider />}
            </div>
          ))}
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                fontSize: 18,
                fontWeight: "400",
              }}
            >
              <Typography>{t('total')}</Typography>
              <Typography style={{fontSize:"24px",fontWeight:"500"}}>${orderDetails?.data?.subtotal}</Typography>
            </div>
          </div>

          <Button
            type="primary"
            style={{ height: 48, backgroundColor: "#1562FF", borderRadius: 6 }}
            block
            onClick={() => navigate("/home/template-management/template")}>
            {t('go_to_panel')}
          </Button>

          {/* <Typography style={{ fontSize: 12, textAlign: "center" }}>
            Read One Site Cart <a href="#">Payment Policy</a> here.
          </Typography> */}
        </div>
        </div>
      </div>

      {/* Contact Us Section */}
      <div
        style={{
          width: "100%",
          maxWidth: 735,
          marginTop: 32,
          backgroundColor: "#fff",
          borderRadius: 16,
          padding: 24,
          display: "flex",
          flexDirection: "column",
          gap: 16,
        }}
      >
        <Typography style={{ fontSize: 18, fontWeight: "bold" }}>
          {t('contact_us')}
        </Typography>

        {/* Phone */}
        <div
          style={{
            border: "1px solid #EAEAEA",
            borderRadius: 8,
            padding: 16,
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            cursor:"pointer"
          }}
          onClick={handlePhoneClick}
        >
          <div style={{ display: "flex", gap: 12, alignItems: "center" }}>
            <img src={PhoneIcon} alt="Phone" width={20} height={20} />
            <Typography style={{ fontWeight: "bold" }}>{t('phone_number')}</Typography>
          </div>
          <img src={ArrowRight} alt="Arrow" width={20} height={20} />
        </div>
        <Typography style={{ fontSize: 14, color: "#333" }}>
          {orderDetails?.data?.contact?.phone_numbers?.map((number, index, arr) => (
            <span key={index}>
              {number}
              {index !== arr.length - 1 && ', '}
            </span>
          ))}
        </Typography>

        {/* Email */}
        <div
          style={{
            border: "1px solid #EAEAEA",
            borderRadius: 8,
            padding: 16,
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            cursor:"pointer"
          }}
           onClick={handleEmailClick}
        >
          <div style={{ display: "flex", gap: 12, alignItems: "center" }}>
            <img src={EmailIcon} alt="Email" width={20} height={20} />
            <Typography style={{ fontWeight: "bold" }}>{t('email_address')}</Typography>
          </div>
          <img src={ArrowRight} alt="Arrow" width={20} height={20} />
        </div>
        <Typography style={{ fontSize: 14, color: "#333" }}>
          {orderDetails?.data?.contact?.email}
        </Typography>
      </div>
    </div>
  );
};

export default OrderDetails;
